import { AxiosRequestConfig } from "axios";
import { URL_BACKEND_ROOT } from "../app/AppConst";
import { SysJobRunSearch } from "../dto/sysjob/SysJobRunSearch";
import { ReadResponse } from "../dto/response/ReadResponse";
import { ApiClient } from "../util/ApiUtility";

export const onSysJobRunSearch = async (data: SysJobRunSearch) => {
    const requestConfig: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/sys-job/run/search',
      params: {
        startDate: data.startDate,
        endDate: data.endDate,
        status: data.status,
        offset: data.offset,
        limit: data.limit
      }
    }
    const response = await ApiClient().request<ReadResponse>(requestConfig);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error("Амжилтгүй");
    }
  }